interface IconProps {
  width?: string;
  height?: string;
  className?: string;
}

const ChartIcon = ({ width = "20", height = "20", className = "" }: IconProps) => {
  return (
    <span className={className}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.66602 1.66663V15.8333C1.66602 17.2166 2.78268 18.3333 4.16602 18.3333H18.3327"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.16602 14.1667L7.99102 9.70005C8.62435 8.96672 9.74935 8.91671 10.4327 9.60837L11.2243 10.4001C11.9077 11.0834 13.0327 11.0417 13.666 10.3084L17.4993 5.83337"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};

export default ChartIcon;